import React from 'react';
import { BaasicInput, BaasicCheckbox, BaasicDropdown, Loader } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { translate } from 'core/utils';
import _ from 'lodash';

const UserCreateTemplate = ({
	t,
	userCreateViewStore: {
		form,
		loading,
		getPrinters,
		notification,
		showNotification,
		hasPiiAccess,
		canSetPii,
		isHavingAPISecret,
		generateApiSecret,
		onCheckPiiAccess,
		onCheckEnableEmailNotification,
		canSetEnableEmailNotification,
		enableEmailNotification,
		onUserPhoneChange,
		isSuperAdmin,
		organizationDropdownStore,
		countryDropdownStore,
		roleDropdownStore,
		labelPrinterDropdownStore,
		packingSlipPrinterDropdownStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<form className="ReactModal__form" onSubmit={form.onSubmit}>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{translate('CREATEUSER')}</h3>
			</div>
			<div className="ReactModal__body">
				{isSuperAdmin && (
					<BaasicDropdown
						dropdownStore={organizationDropdownStore}
						placeholder={t('PLACEHOLDER.ORGANIZATION')}
						className="w--200--px spc--right--sml"
					/>
				)}
				<BaasicInput autoFocus field={form.$('userName')} />
				<BaasicInput field={form.$('email')} />
				<BaasicDropdown dropdownStore={countryDropdownStore} />
				<BaasicInput
					field={form.$('userPhone')}
					onKeyUp={onUserPhoneChange(form.$('userPhone').value)}
					disabled={form.$('countryId').isEmpty}
				/>
				<BaasicInput field={form.$('password')} className="fs-mask" />
				<BaasicInput field={form.$('confirmPassword')} className="fs-mask" />
				<BaasicDropdown dropdownStore={roleDropdownStore} className="spc--bottom--sml flex--grow--1" />
				<div className="inputgroup">
					<div className="inputgroup--main">
						<BaasicInput field={form.$('apiKey')} className="fs-mask" />
					</div>
					<div className="inputgroup--aside align--v--bottom">
						<button
							className="btn btn--med btn--secondary spc--left--sml spc--bottom--sml"
							type="button"
							disabled={loading}
							onClick={getPrinters}
						>
							{translate('LOGINFORM.PRINTNODE.GETPRINTERS')}
						</button>
					</div>
					{showNotification && <p className="type--color--warning spc--bottom--sml">{translate(notification)}</p>}
				</div>
				<BaasicDropdown
					dropdownStore={labelPrinterDropdownStore}
					isClearable={true}
					className="spc--bottom--sml flex--grow--1"
				/>
				<BaasicDropdown
					dropdownStore={packingSlipPrinterDropdownStore}
					isClearable={true}
					className="spc--bottom--sml flex--grow--1"
				/>
				<div className="inputgroup">
					<div className="inputgroup--main">
						<BaasicInput field={form.$('apiSecret')} className="fs-mask" disabled />
					</div>
					<div className="inputgroup--aside align--v--bottom">
						{!isHavingAPISecret ? (
							<button
								className="btn btn--med btn--secondary spc--bottom--sml spc--left--sml"
								type="button"
								onClick={generateApiSecret}
							>
								{translate('LOGINFORM.GENERATEAPISECRET')}
							</button>
						) : null}
					</div>
					{showNotification && <p className="type--color--warning spc--bottom--sml">{translate(notification)}</p>}
				</div>
				<div className="spc--bottom--sml">
					<BaasicCheckbox
						className="input--check"
						id="pii-access"
						onChangeCallback={onCheckPiiAccess}
						label={'LOGINFORM.PIIACCESS'}
						checked={hasPiiAccess}
						disabled={!canSetPii}
					/>
				</div>
				{canSetEnableEmailNotification && this.roleDropdownStore &&
					_.find(this.roleDropdownStore.value.slice(), role => {
						return role.label == 'Warehouse Administrator' || role.label == 'Warehouse Account Owner';
					}) && (
						<div className="spc--bottom--sml">
							<BaasicCheckbox
								id="enable-email-notification"
								onChangeCallback={onCheckEnableEmailNotification}
								label={'USEREDIT.EMAILNOTIFICATION'}
								checked={enableEmailNotification}
							/>
						</div>
					)}
				{form.error && (
					<div>
						<p className="type--color--warning">{translate(form.error)}</p>
					</div>
				)}
			</div>
			<div className="ReactModal__footer">
				<button className="btn btn--med btn--primary spc--bottom--sml" type="submit" disabled={loading}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{translate('SAVE')}
				</button>
			</div>
		</form>
	);
};

export default defaultTemplate(UserCreateTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/user/pages/UserCreateTemplate.jsx